import { BASE_URL } from "../util/constants";
import { AUTH } from "../util/constants";

export const apiManager = async (method, path, data, addHeaders) => {
    const headers = {
        'Content-Type': 'application/json',
        ...(AUTH ? { Authorization: AUTH } : {}),
        ...(addHeaders || {})
    };

    let config = {
        method: method,
        headers,
        body: data === undefined ? undefined : JSON.stringify(data)
    }

    if (method === 'GET' || data === undefined) {
        delete config.body;
    }

    try {
        const response = await fetch(`${BASE_URL}${path}`, config);
        const text = await response.text();
        const payload = text ? JSON.parse(text) : {};

        if (!response.ok) {
            return {
                ...payload,
                status: false,
                httpStatus: response.status,
                message: payload.message || 'Request failed',
            };
        }

        return payload;
    } catch (error) {
        console.error('API request failed:', error);
        return {
            status: false,
            message: error?.message || 'Network request failed',
            error,
        };
    }

}